import React, { useState, useContext } from "react";
import { CartContext } from "../context/CartContext";
import Footer from "./Footer";
import products from "../products"; 

const Collection = () => {
  const { addToCart } = useContext(CartContext);
  const [cartNotification, setCartNotification] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleAddToCart = (product) => {
    addToCart(product);
    setCartNotification(true);
    setTimeout(() => {
      setCartNotification(false);
    }, 3000);
  };

  const openImageModal = (image) => setSelectedImage(image);
  const closeImageModal = () => setSelectedImage(null);

  return (
    <section className="bg-grey text-white relative">
      {cartNotification && (
        <div className="fixed z-50 flex items-center gap-2 px-4 py-2 bg-grey shadow-lg rounded-lg border border-orange text-white
          top-4 right-4 md:right-4 md:top-4 w-auto md:w-64
          mx-auto md:mx-0">
          <span className="text-lg">✔</span>
          <p>Added to cart</p>
        </div>
      )}

      <div className="flex justify-between items-center mb-6 px-6 pt-6">
        <button className="flex items-center gap-2 px-4 py-2 border border-white" disabled>
          &#9776; Filter
        </button>
        <p>Showing 1-12 of 12 results</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mb-10 p-6">
        {products.map((product) => (
          <div key={product.id} className="relative bg-white text-black overflow-hidden shadow-lg">
            <img
              src={product.image}
              alt={product.name}
              className="w-full h-48 object-contain cursor-pointer"
              onClick={() => openImageModal(product.image)}
            />
            <div className="absolute top-3 right-3 bg-grey text-white px-2 py-1 text-xs font-bold rounded-full">
              {product.discount}
            </div>
            <div className="p-4">
              <h3 className="font-bold">{product.name}</h3>
              <p className="text-gray-600 text-sm">{product.description}</p>
              <p className="text-lg font-bold">₦{product.price.toLocaleString()}</p>
              <p className="text-gray-400 text-sm line-through">₦{product.oldPrice.toLocaleString()}</p>
              <button
                onClick={() => handleAddToCart(product)}
                className="mt-2 bg-orange text-white px-4 py-2 w-full">
                Add to Cart
              </button>
            </div>
          </div>
        ))}
      </div>

      <Footer />

      {/* Image Modal */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center" onClick={closeImageModal}>
          <div className="bg-white p-6 rounded-lg shadow-lg relative max-w-3xl" onClick={(e) => e.stopPropagation()}>
            <button className="absolute top-4 right-4 text-2xl font-bold text-gray-600 hover:text-black" onClick={closeImageModal}>
              &times;
            </button>
            <img src={selectedImage} alt="Selected Product" className="w-full h-auto object-contain rounded-lg" />
          </div>
        </div>
      )}
    </section>
  );
};

export default Collection;